var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.0455 41.3636V47.2727H26.591C26.591 49.6235 25.6571 51.878 23.9949 53.5403C22.3326 55.2025 20.0781 56.1364 17.7273 56.1364C15.3765 56.1364 13.122 55.2025 11.4598 53.5403C9.79753 51.878 8.86368 49.6235 8.86368 47.2727H2.95459V14.7727C2.95459 13.2056 3.57715 11.7025 4.68532 10.5944C5.79349 9.48621 7.29649 8.86365 8.86368 8.86365H47.2728C48.84 8.86365 50.343 9.48621 51.4511 10.5944C52.5593 11.7025 53.1819 13.2056 53.1819 14.7727V41.3636H62.0455ZM17.7273 44.3182C16.9437 44.3182 16.1922 44.6295 15.6381 45.1836C15.0841 45.7376 14.7728 46.4891 14.7728 47.2727C14.7728 48.0563 15.0841 48.8078 15.6381 49.3619C16.1922 49.916 16.9437 50.2273 17.7273 50.2273C18.5109 50.2273 19.2624 49.916 19.8165 49.3619C20.3706 48.8078 20.6819 48.0563 20.6819 47.2727C20.6819 46.4891 20.3706 45.7376 19.8165 45.1836C19.2624 44.6295 18.5109 44.3182 17.7273 44.3182Z",
    fill: "#A82323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.6188793d288a710f57fe08fb9cc97c5c.svg";
export { ForwardRef as ReactComponent };